export const VERCEL_ENV = (process.env.NEXT_PUBLIC_VERCEL_ENV ??
  "development") as "production" | "preview" | "development";
